export default __webpack_public_path__ + "static/media/bci-3.06b18ff6.svg";